import React from 'react';
import { whyPillars } from '../../mock';

export default function WhyUs() {
  return (
    <section id="why" className="py-24 lg:py-40 bg-[#0F1C40] text-[#F1EDE4] relative overflow-hidden">
      {/* decorative spark */}
      <div className="absolute -bottom-20 -left-20 w-[420px] h-[420px] opacity-15 pointer-events-none">
        <svg viewBox="0 0 200 200" className="w-full h-full spark-spin">
          <path d="M100 0 L110 90 L200 100 L110 110 L100 200 L90 110 L0 100 L90 90 Z" fill="#4ECDC4" />
        </svg>
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-16 lg:mb-24 items-end">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-widest text-[#4ECDC4] mb-4">
              <span className="w-6 h-px bg-[#4ECDC4]" />
              <span>Value Proposition</span>
            </div>
            <p className="text-white/60 text-lg mt-6 max-w-sm">Four pillars. One accountable partner.</p>
          </div>
          <div className="lg:col-span-7">
            <h2 className="text-6xl lg:text-8xl xl:text-9xl tracking-tight leading-[0.95] font-serif italic text-[#4ECDC4]">
              Why <span className="text-[#F1EDE4] not-italic font-sans font-medium">EvolveBPM.</span>
            </h2>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-white/10">
          {whyPillars.map((p, i) => (
            <div key={p.title} className="bg-[#0F1C40] p-10 lg:p-14 hover:bg-[#12234C] transition-colors duration-500 reveal group" style={{ transitionDelay: `${i * 100}ms` }}>
              <div className="flex items-center gap-3 mb-10">
                <span className="w-2 h-2 rounded-full bg-[#4ECDC4]" />
                <span className="text-[10px] font-mono uppercase tracking-widest text-white/50">{p.tag}</span>
              </div>
              <h3 className="text-3xl lg:text-5xl font-serif italic font-normal mb-6 text-[#F1EDE4] group-hover:text-[#4ECDC4] transition-colors duration-500">
                {p.title}
              </h3>
              <p className="text-white/70 leading-relaxed text-lg max-w-md">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
